import React from 'react';
import './AboutEmblem.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const AboutEmblem = () => {
  return (
    <div id="aboutEmblemPage" className="emblem-page">
      <Navbar />
      
      <div id="aboutEmblemContainer" className="emblem-container">
        <div id="aboutEmblemHeader" className="page-header">
          <h1>University Emblem</h1>
          <div className="header-underline"></div>
        </div>
        
        <div id="aboutEmblemContent" className="emblem-content">
          <div id="aboutEmblemDescription" className="emblem-description">
            <h2>Significance of Our Emblem</h2>
            <p>
              The emblem of Rayalaseema University represents the history as well as the geographical significance of Kurnool District, which is popularly known as the gateway to Rayalaseema. The Sudarsana Chakra is the symbol of Dharma. The temple at Srisailam on the right bank of the Krishna is a rare but significant confluence of Jyothirlinga and Astadasa Sakti Peetha. Nandi, the vehicle of Lord Shiva, is found in more than one place in this region. The great Indian Bustard is the unique and proud possession of Kurnool District alone in the whole world. The Nallamala forest is a reservoir of various flora and fauna and also the abode of many pilgrimage centers. The Tungabhadra and the Krishna along with their tributaries border Kurnool District and wet the parched lands and quench the thirst of the people of Rayalaseema. The Konda Reddy Fort is a proud witness to the Vijayanagara Dynasty, the exuberant life style of the Nawabs and the life of Konda Reddy. The Lotus is the abode of Saraswathi, Goddess of enlightenment, knowledge and wisdom. The Motto "Vidyaya Vindate Amrutam" is from the Kenopanishad, which conveys the message that one can attain immortal wisdom through knowledge.
            </p>
          </div>
          
          <div id="aboutEmblemImageContainer" className="emblem-image-container">
            <div className="emblem-image">
              <img src="/logo.png" alt="Rayalaseema University Emblem" />
            </div>
            <h3>Official Emblem of Rayalaseema University</h3>
            <p className="motto-text">
              <em>"Vidyaya Vindate Amrutam"</em>
            </p>
            <p className="motto-translation">
              Through knowledge, one attains immortality
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutEmblem;